import { WithdrawalHistory } from './WithdrawalHistory';

export default WithdrawalHistory;
